<template>
  <div class="bg-blue">
    <h3 class="bold bigText2">
      {{ $t("Points forts & points faibles du bien") }}
    </h3>
    <div class="row">
      <div class="col-md-7 mt-4">
        <div class="p-4">
          <div>
            <b-embed
              type="iframe"
              aspect="16by9"
              :src="
                ooftopMapApi +
                  'radar-chart?e=' +
                  value.estimation_score +
                  '&i=' +
                  value.indice / 2 +
                  '&lv=' +
                  (value.liquidite == 0 ? 1 : value.liquidite == 1 ? 3 : 5) +
                  '&ps=' +
                  value.quartier_proximite_note +
                  '&ds=' +
                  value.quartier_densite_note +
                  '&r=' +
                  value.risques_nb_eval_score5 +
                  '&_api_key=' +
                  ooftopMapApiKey +
                  '&lang=' +
                  $i18n.locale +
                  '&color=' +
                  color
              "
              width="100%"
              allowfullscreen
              class="mb-4"
            ></b-embed>
          </div>
        </div>
      </div>
      <div class="col-md-5 mt-4">
        <div class="p-4">
          <ul class="nolist ">
            <li
              v-if="
                rights.rapport.marche_immo &&
                  rights.rapport.marche_immo_bien_vendus
              "
            >
              <h5 class="bold">
                {{ $t("Marché immobilier") }}
                <span
                  :class="'badge p-2 badge-' + value.marche_immo_label_badge"
                  >{{ value.marche_immo_label }}</span
                >
              </h5>
              <p>
                <b>{{ value.marche_immo_nb_transactions }}</b>
                {{
                  $t(
                    "transactions résidentielles publiées au cours " +
                      (parseInt(value.marche_immo_nb_transactions_annee) >=
                        2021 &&
                      value.version != "5" &&
                      value.version != "v5" &&
                      value.version != "7" &&
                      value.version != "v7" &&
                      value.version != "9" &&
                      value.version != "v9" &&
                      value.version != "11" &&
                      value.version != "v11"
                        ? "du premier semestre"
                        : "de l’année")
                  )
                }}
                {{ value.marche_immo_nb_transactions_annee }}
                {{ $t("dont") }}
                {{ value.marche_immo_nb_transactions_a }}
                {{
                  $t(
                    "appartement" +
                      (value.marche_immo_nb_transactions_a > 1 ? "s" : "") +
                      " et"
                  )
                }}
                {{ value.marche_immo_nb_transactions_m }}
                {{
                  $t(
                    "maison" +
                      (value.marche_immo_nb_transactions_m > 1 ? "s" : "")
                  )
                }}
              </p>
            </li>
            <li class="mt-2">
              <h5 class="bold">
                {{ $t("Quartier") }}
                <span
                  :class="
                    'badge p-2 badge-sm badge-' + value.quartier_label_badge
                  "
                  >{{ value.quartier_label }}</span
                >
              </h5>
              <p>
                <b>{{ $t("Commerces et services de proximité") }} :</b>
                {{ value.quartier_proximite_val }} ({{
                  value.quartier_proximite_lib
                }})
              </p>
              <p>
                <b>{{ $t("Densité de commerces") }} :</b>
                {{ value.quartier_densite }}
              </p>
            </li>
            <li class="mt-2">
              <h5 class="bold">
                {{ $t("Risques") }}
                <span
                  :class="
                    'badge p-2 badge-sm badge-' +
                      value.risques_nb_eval_score3_badge
                  "
                  >{{ value.risques_nb_eval_score3_badge_label }}</span
                >
              </h5>
              <p>
                <span v-if="value.risques_nb_eval_score3 == 0"
                  >{{
                    $t(
                      "Le bien est situé dans une zone peu sensible à des risques naturels ou technologiques"
                    )
                  }}<span v-if="value.risques_label != ''">
                    : {{ value.risques_label }}</span
                  ></span
                >
                <span v-if="value.risques_nb_eval_score3 == 1"
                  >{{
                    $t(
                      "Le bien est situé dans une zone pouvant être impactée par des risques naturels ou technologiques"
                    )
                  }}<span v-if="value.risques_label != ''">
                    : {{ value.risques_label }}</span
                  ></span
                >
                <span v-if="value.risques_nb_eval_score3 == 2"
                  >{{
                    $t(
                      "Le bien est situé dans une zone présentant de nombreux risques naturels ou technologiques"
                    )
                  }}<span v-if="value.risques_label != ''">
                    : {{ value.risques_label }}</span
                  ></span
                >
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EvaluationPF",
  components: {},
  data() {
    return {
      nodata: this.$i18n.t("Données insuffisantes"),
    };
  },
  props: {
    value: Object,
    rights: Object,
    ooftopMapApiKey: String,
    ooftopMapApi: String,
    color: String,
  },
  watch: {},
  computed: {},
  methods: {},
  mounted() {},
};
</script>
